import { render } from "./AccountSettingsConsulting.vue?vue&type=template&id=1f01a978"
import script from "./AccountSettingsConsulting.vue?vue&type=script&lang=js"
export * from "./AccountSettingsConsulting.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__